const actions = {
    OPENING_SET_CURRENT_STEP: 'OPENING_SET_CURRENT_STEP',
    OPENING_CALCULATE_TOTAL: 'OPENING_CALCULATE_TOTAL',
    OPENING_READ_REQUEST: 'OPENING_READ_REQUEST',
    OPENING_READ_SUCCESS: 'OPENING_READ_SUCCESS',
    OPENING_READ_ERROR: 'OPENING_READ_ERROR',
    OPENING_UPDATE_REQUEST: 'OPENING_UPDATE_REQUEST',
    OPENING_UPDATE_SUCCESS: 'OPENING_UPDATE_SUCCESS',
    OPENING_UPDATE_ERROR: 'OPENING_UPDATE_ERROR',
    OPENING_SET_DATE: 'OPENING_SET_DATE',
    OPENING_SET_PAGINATION: 'OPENING_SET_PAGINATION',
    OPENING_SET_PAGINATION_COMPLETED: 'OPENING_SET_PAGINATION_COMPLETED',
    OPENING_SCROLL_TO_ERROR_LINE: 'OPENING_SCROLL_TO_ERROR_LINE',
    OPENING_RESET: 'OPENING_RESET',

    OPENING_READ_IMPORTED_PRODUCTS_DETAIL_REQUEST: 'OPENING_READ_IMPORTED_PRODUCTS_DETAIL_REQUEST',
    OPENING_READ_IMPORTED_PRODUCTS_DETAIL_SUCCESS: 'OPENING_READ_IMPORTED_PRODUCTS_DETAIL_SUCCESS',
    OPENING_READ_IMPORTED_PRODUCTS_DETAIL_ERROR: 'OPENING_READ_IMPORTED_PRODUCTS_DETAIL_ERROR',

    setCurrentStep: currentStep => ({
        type: actions.OPENING_SET_CURRENT_STEP,
        currentStep,
    }),
    read: request => ({
        type: actions.OPENING_READ_REQUEST,
        request,
    }),
    update: request => ({
        type: actions.OPENING_UPDATE_REQUEST,
        request,
    }),
    setDate: date => ({
        type: actions.OPENING_SET_DATE,
        date,
    }),
    reset: () => ({
        type: actions.OPENING_RESET,
    }),
    calculateTotal: opening_items => ({
        type: actions.OPENING_CALCULATE_TOTAL,
        opening_items,
    }),
    setPagination: (tableName, paginationData) => ({
        type: actions.OPENING_SET_PAGINATION,
        tableName,
        paginationData,
    }),
    scrollToErrorLine: (tableName, errorItem, allErrorItems) => ({
        type: actions.OPENING_SCROLL_TO_ERROR_LINE,
        tableName,
        errorItem,
        allErrorItems,
    }),
    readImportedProductsDetail: allProductIds => ({
        type: actions.OPENING_READ_IMPORTED_PRODUCTS_DETAIL_REQUEST,
        allProductIds,
    }),
};
export default actions;
